<template>
  <div class="mr-1 notificacion-faltas">
    <span id="icon-faltas">
      <feather-icon
        :badge="contador >= 99 ? '99+' : contador"
        badge-classes="bg-danger"
        icon="UserXIcon"
        class="text-info cursor-pointer"
        size="22"
        @click="showModal = true"
      />
      <b-tooltip target="icon-faltas" variant="primary" triggers="hover">{{
        $t("Colaboradores con mas faltas") | capitalize
      }}</b-tooltip>
    </span>

    <b-modal
      v-model="showModal"
      title-class="h3 text-white"
      size="xl"
      centered
      :title="`Colaboradores con faltas: ${filters[0].model} - ${filters[1].model}`"
      hide-footer
      modal-class="modal-primary"
      @hidden="showModal = false"
    >
      <filter-slot
        :filter="filters"
        :filterPrincipal="filterPrincipal"
        :paginate="paginate"
        @reload="$refs['ref-faltas-recurrentes'].refresh()"
      >
        <template #table>
          <b-table
            :fields="fields"
            :items="index"
            small
            responsive
            hover
            sticky-header="45vh"
            show-empty
            empty-text="No hay colaboradores con faltas registradas"
            class="position-relative font-small-3 table-fixed"
            ref="ref-faltas-recurrentes"
            :per-page="paginate.perPage"
            :current-page="paginate.currentPage"
            table-class="text-nowrap"
            :busy.sync="isBusy"
            primary-key="id"
          >
            <template #cell(faltas)="data">
              <div class="d-flex flex-wrap gap-3">
                <b-badge
                  v-for="(falta, index) in data.value"
                  :key="index"
                  variant="light-warning"
                  class="px-2"
                >
                  {{ falta.fecha }}
                </b-badge>
              </div>
            </template>

            <template #cell(total_faltas)="data">
              <div class="text-center text-danger">
                {{ data.value }}
              </div>
            </template>

            <template #cell(empleado)="data">
              <router-link
                target="_blank"
                :class="[textLink]"
                :to="{
                  name: 'rrhh-employees-information',
                  params: { id: data.item.id_personal },
                }"
              >
                <feather-icon
                  v-if="data.item.tipo_personal == 'Conductor'"
                  icon="TruckIcon"
                  size="16"
                  class="text-warning"
                />
                <feather-icon
                  v-else
                  icon="UserIcon"
                  size="16"
                  class="text-success"
                />
                {{ data.value | capitalize }} </router-link
              ><br />
              <span class="text-primary" style="opacity: 0.7">
                {{ data.item.tipo_personal | capitalize }}
              </span>
              <br />
              <span style="opacity: 0.7">
                {{ data.item.area | capitalize }}
              </span>
              <br />
              <span class="text-info" style="opacity: 0.7">
                {{ data.item.dni | capitalize }}
              </span>
            </template>
          </b-table>
        </template>
      </filter-slot>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AttendanceService from "@/views/rrhh/views/attendance/services/attendance.service.js";
import moment from "moment";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

export default {
  components: {
    FilterSlot,
  },
  data() {
    return {
      showModal: false,
      faltas: [],
      fields: [
        {
          key: "empleado",
          label: "Empleado",
          thStyle: "width: 20%;",
          tdStyle: "width: 20%;",
        },
        {
          key: "total_faltas",
          label: "Total Faltas",
          thStyle: "width: 10%; text-align: center;",
          tdStyle: "width: 10%; text-align: center;",
        },
        {
          key: "faltas",
          label: "Faltas",
          thStyle: "width: 70%; text-align: center;",
          tdStyle: "width: 70%;",
        },
      ],
      filters: [
        {
          // [0]
          type: "b-form-datepicker",
          margin: true,
          showLabel: true,
          label: "Desde",
          placeholder: "Date",
          class: "font-small-2",
          model: null,
          locale: "es",
          dateFormatOptions: {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
          },
          cols: 12,
        },
        {
          // [1]
          type: "b-form-datepicker",
          margin: true,
          showLabel: true,
          label: "Hasta",
          placeholder: "Date",
          class: "font-small-2",
          model: null,
          locale: "es",
          dateFormatOptions: {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
          },
          cols: 12,
        },
      ],
      isBusy: false,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      contador: 0,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      skin: "appConfig/skin",
    }),
  },
  mounted() {
    this.filters[0].model = moment().startOf("month").format("YYYY-MM-DD"); // Primer día del mes
    this.filters[1].model = moment().format("YYYY-MM-DD"); // Hoy

    this.fetchContadorFaltas();
  },
  methods: {
    async fetchContadorFaltas() {
      try {
        this.addPreloader();
        const params = {
          page: 1,
          perpage: 10000,
          search_txt: this.filterPrincipal.model,
          from: this.filters[0].model,
          to: this.filters[1].model,
        };

        const { data } = await AttendanceService.getNotificacionFaltas(params);
        this.contador = data?.data?.length || 0;
      } catch (error) {
        console.error(error);
      } finally {
        this.removePreloader();
      }
    },

    async index(ctx) {
      try {
        this.addPreloader();

        if (!this.filters[0].model) {
          this.filters[0].model = moment()
            .startOf("month")
            .format("YYYY-MM-DD"); // Primer día del mes
        }

        if (!this.filters[1].model) {
          this.filters[1].model = moment().format("YYYY-MM-DD"); // Hoy
        }

        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search_txt: this.filterPrincipal.model,
          from: this.filters[0].model,
          to: this.filters[1].model,
        };

        const { data } = await AttendanceService.getNotificacionFaltas(params);

        this.paginate = {
          from: data.from,
          to: data.to,
          of: data.total,
          perPage: data.per_page,
          currentPage: data.current_page,
        };

        return data.data || [];
      } catch (error) {
        console.error(error);
        return [];
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style lang="scss">
.notificacion-faltas {
  .table-fixed {
    table-layout: fixed;
    width: 100%;
  }
}
</style>
